import { Link } from 'react-router-dom';
import GNALogo from "@/assets/gna_logo.png";

const PageFooter = () => {
  return (
    <footer className="bg-green-900 text-white">
      <div className="border-t border-white/10 bg-green-950">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-10">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
            {/* Logo & Mission */}
            <div className="flex flex-col items-center lg:items-start gap-3">
              <img
                src={GNALogo}
                alt="GNA Logo"
                className="h-12 w-auto object-contain"
              />
              <p className="text-green-300/70 text-sm text-center lg:text-left max-w-xs">
                GNA — On A Mission To Build. Empowering African businesses through technology and innovation.
              </p>
            </div>

            {/* Event Info */}
            <div className="flex flex-col items-center gap-2 text-center">
              <p className="text-white font-semibold text-sm">GNA AI Business Summit 2026</p>
              <p className="text-green-300/70 text-xs">May 30th, 2026 · Live Online</p>
              <div className="flex flex-wrap items-center justify-center gap-3 mt-2">
                <span className="text-green-300/70 text-xs">🇺🇸 12:30 PM CST</span>
                <span className="text-green-600">·</span>
                <span className="text-green-300/70 text-xs">🇳🇬 6:30 PM WAT</span>
                <span className="text-green-600">·</span>
                <span className="text-green-300/70 text-xs">🇬🇧 6:30 PM BST</span>
              </div>
            </div>

            {/* Links */}
            <div className="flex flex-col items-center lg:items-end gap-3">
              <div className="flex flex-wrap items-center justify-center gap-4">
                <Link to="/" className="text-green-300/70 text-sm hover:text-white transition-colors cursor-pointer">Home</Link>
                <Link to="/schedule" className="text-green-300/70 text-sm hover:text-white transition-colors cursor-pointer">Schedule</Link>
                <Link to="/speakers" className="text-green-300/70 text-sm hover:text-white transition-colors cursor-pointer">Speakers</Link>
                <Link to="/register" className="text-green-300/70 text-sm hover:text-white transition-colors cursor-pointer">Register</Link>
                <Link to="/premium" className="text-green-300/70 text-sm hover:text-white transition-colors cursor-pointer">Premium</Link>
              </div>
              {/* <a
                href="https://event.greatnigeria.org"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="text-amber-400 text-sm hover:text-amber-300 transition-colors cursor-pointer"
              >
                event.greatnigeria.org
              </a> */}
            </div>
          </div>

          <div className="mt-8 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-green-400/50 text-xs">
              © 2026 Great Nigerian Assembly (GNA) · In Strategic Collaboration with CPI Technologies Inc.
            </p>
            <p className="text-green-500/40 text-xs">All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default PageFooter;
